import React, { useState, useEffect, useCallback, useRef } from 'react';
import './_capDocumentationChatBot.scss';
import CapHeading from '../../CapHeading';
import CapIcon from '../../CapIcon';
import CapRow from '../../CapRow';
import useWebsocket from '../hooks/useWebsocket';
import AiraContainer from '../UtilComponents/AiraContainer';
import LocaleHoc from '../../LocaleHoc';
import { rootClsPrefix } from '../constants';
import { clsPrefix, SERVER_URL } from './constants';
import { MetaBlock } from './MetaBlock';
import Markdown from 'markdown-to-jsx';
import { sendFeedbackApi } from "./api"
import * as action from './actions';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { makeSelectMessageDetail } from './selectors';
import { AiraChatBot, AiraChatTitleBar } from '../UtilComponents/Icons';
import MultiLineInputBox from '../UtilComponents/MultiLineInpuxBox';


const DocumentationChatBot = ({ textBotPlaceholder, textChatBotLoader, textChatBotDesc, textChatBot, actions, getAPICallObject, request }) => {
    const [query, setQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [answerChunks, setAnswerChunks] = useState([]);
    const [conversationHistory, setConversationHistory] = useState([]);
    const [messageId, setmessageId] = useState(null);

    const chatContainerRef = useRef(null);

    const processDynamicText = (text) => {
        let processedText = text.replace(/\\n\\n/g, '\n\n');
        return processedText.trim();
    };
    const onMessage = useCallback((msg) => {
        const isFinish = msg.isFinish === 'True';

        if (msg.messageId) {
            setmessageId(msg.messageId);
        }
        setAnswerChunks((prevChunks) => [...prevChunks, msg.token]);
        if (isFinish) {
            setLoading(false);
            setConversationHistory((prevHistory) => {
                const updatedHistory = [...prevHistory];
                updatedHistory[updatedHistory.length - 1].answer = processDynamicText([...prevHistory[updatedHistory.length - 1].answer, ...answerChunks, msg.token].join(''));
                return updatedHistory;
            });
            setAnswerChunks([]);
        }
    }, [answerChunks]);
    const getAnswer = async () => {
        setAnswerChunks([]);
        setLoading(true);

        sendMessage({
            q: query,
        });
        setConversationHistory(prevHistory => [
            ...prevHistory,
            { userQuery: query, answer: '' }
        ]);
    };

    const onSubmitHandler = () => {
        if (query.trim()) {
            getAnswer();
            setQuery('');
        }
    };

    const likeAnswer = (feedbackType, messageId, index) => () => {

        const payload = {
            feedback: feedbackType === 'like' ? 'UP' : 'DOWN',
            additionalFeedback: "",
            additionalFeedbackDetails: "",
        };

        const apiCall = sendFeedbackApi(request, getAPICallObject);
        actions.sendFeedbackQuery({ payload, sendFeedbackApi: apiCall(payload, messageId) });
        setConversationHistory((prevHistory) => {
            const updatedHistory = [...prevHistory];
            if (feedbackType === 'like') {
                updatedHistory[index].likeButton = true;
                updatedHistory[index].disLikeButton = false;
            } else {
                updatedHistory[index].disLikeButton = true;
                updatedHistory[index].likeButton = false;
            }
            return updatedHistory;
        });
    };

    const onError = useCallback(() => {
        setLoading(false);
    }, []);

    const { sendMessage, resetConnection } = useWebsocket(SERVER_URL, onMessage, onError);

    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    }, [conversationHistory, answerChunks]);

    const onHide = () => {
        setQuery('');
        setAnswerChunks([]);
        setLoading(false);
        setConversationHistory([]);
        resetConnection();
    }
    const ResponseWithIcon = ({ content, index, likeButton, disLikeButton, messageId }) => {
        return (
            <div style={{ display: 'flex', width: "90%" }}>
                <CapHeading style={{ marginRight: '0.60rem' }}>
                    <CapIcon size="s" type="three-star-dark" className="chat-loader-icon" />
                </CapHeading>
                {content ?
                    <CapHeading className={`answer-received ${clsPrefix}-response`}>
                        <Markdown>{processDynamicText(content)}</Markdown>
                        <MetaBlock
                            likeAnswer={likeAnswer}
                            likeButton={likeButton}
                            disLikeButton={disLikeButton}
                            content={processDynamicText(content)}
                            messageId={messageId}
                            index={index}
                        />
                    </CapHeading>
                    :
                    <CapHeading type="h6" style={{ display: 'flex', alignItems: 'center' }}>
                        {textChatBotLoader}
                    </CapHeading>
                }
            </div>
        )
    };

    return (
        <AiraContainer
            titlePadding="0.95rem"
            popupWidth="32rem"
            iconSize="48px"
            iconProps={{
                svgProps: {
                    style: {
                        padding: '13px',
                    }
                }
            }}
            Icon={AiraChatBot}
            title="Aira"
            onHide={onHide}
            titleBarIcon={AiraChatTitleBar}
            popupHeight="100vh"
            popupPlacement={{ type: 'float-br', padding: '0rem' }}
        >
            <div className={`${clsPrefix}-content`}>
                <div className={(conversationHistory.length < 1 ? `${clsPrefix}-no-chat-container` : `${clsPrefix}-chat-container`) + ` ${rootClsPrefix}-no-scrollbar`} ref={chatContainerRef}>
                    <div className={conversationHistory.length < 1 ? `${clsPrefix}-no-answer-container` : `${clsPrefix}-answer-container`}>
                        {conversationHistory.map((conversation, index) => (
                            <CapRow key={index} className='conversation'>
                                <CapHeading className='query-sent'>
                                    {conversation?.userQuery.trim()}
                                </CapHeading>
                                {conversation.answer && (
                                    <ResponseWithIcon
                                        content={conversation.answer}
                                        index={index}
                                        likeButton={conversation.likeButton}
                                        disLikeButton={conversation.disLikeButton}
                                        messageId={messageId}
                                    />
                                )}
                                {!conversation.answer && index === conversationHistory.length - 1 && loading && (
                                    <ResponseWithIcon
                                        content={answerChunks.join('')}
                                        index={index}
                                        likeButton={conversation.likeButton}
                                        disLikeButton={conversation.disLikeButton}
                                        messageId={messageId}
                                    />
                                )}
                            </CapRow>
                        ))}
                    </div>
                </div>
                {
                    conversationHistory.length < 1 &&
                    <CapRow className="doc-bot">
                        <CapIcon
                            type="three-star-dark"
                            size="m"
                            className="three-star-icon"
                        />
                        <CapHeading type="h4">
                            {textChatBot}
                        </CapHeading>
                        <CapHeading type="label4" className='doc-bot-desc'>
                            {textChatBotDesc}
                        </CapHeading>
                    </CapRow>
                }
                <MultiLineInputBox
                    value={query}
                    setValue={setQuery}
                    placeholder={textBotPlaceholder}
                    onSubmit={onSubmitHandler}
                    loading={loading}
                />
            </div >
        </AiraContainer >

    );
};

const mapStateToProps = createStructuredSelector({
    messageDetails: makeSelectMessageDetail(),
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(action, dispatch),
    };
}

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps,
);


export default compose(withConnect)(
    LocaleHoc(DocumentationChatBot, {
        key: 'CapAskAira.DocumentationChatBot',
    }),
);
